var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { isNil } from 'lodash';
import { ElasticsearchFieldModel } from './elasticsearch-field';
export var ElasticsearchFilterOperator;
(function (ElasticsearchFilterOperator) {
    ElasticsearchFilterOperator["Exists"] = "EXIST";
    ElasticsearchFilterOperator["Is"] = "IS";
    ElasticsearchFilterOperator["IsOneOf"] = "IS_ONE_OF";
    ElasticsearchFilterOperator["IsBetween"] = "IS_BETWEEN";
    ElasticsearchFilterOperator["Lookup"] = "LOOKUP";
    ElasticsearchFilterOperator["LessThan"] = "LESS_THAN";
    ElasticsearchFilterOperator["GreaterThan"] = "GREATER_THAN";
    ElasticsearchFilterOperator["Lucene"] = "LUCENE";
})(ElasticsearchFilterOperator || (ElasticsearchFilterOperator = {}));
export class ElasticsearchFilterModel {
    type = ElasticsearchFilterOperator.Is;
    negate = false;
    isDisabled;
    // Indexed by the operators' values, as in ElasticsearchEnhancedFilterModel: TypeScript resolves the same properties,
    // and logz-openapi's schema generator cannot index by an enum member.
    value;
    field = null;
    invalid = false;
    getFilterValueFormat() {
        return {
            [ElasticsearchFilterOperator.Exists]: (_) => 'exists',
            [ElasticsearchFilterOperator.Is]: (value) => value,
            [ElasticsearchFilterOperator.Lookup]: (value) => `Lookup: ${value?.name}`,
            [ElasticsearchFilterOperator.IsOneOf]: (value) => value.join(', '),
            [ElasticsearchFilterOperator.IsBetween]: (value) => `${!isNil(value.gte) ? value.gte : '-∞'} to ${!isNil(value.lt) ? value.lt : '+∞'}`,
        }[this.type](this.value)
            .toString();
    }
}
__decorate([
    Type(() => ElasticsearchFieldModel),
    __metadata("design:type", Object)
], ElasticsearchFilterModel.prototype, "field", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object)
], ElasticsearchFilterModel.prototype, "invalid", void 0);
export class ElasticsearchEnhancedFilterModel {
    type = 'IS';
    negate = false;
    isDisabled;
    value;
    field = null;
    invalid = false;
    get id() {
        return `${this.field?.id ?? 'field'}-${this.negate ? 'NOT_' : ''}${this.isDisabled ? 'DISABLED_' : ''}${this.type}-${JSON.stringify(this.value) ?? ''}`;
    }
}
__decorate([
    Type(() => ElasticsearchFieldModel),
    __metadata("design:type", Object)
], ElasticsearchEnhancedFilterModel.prototype, "field", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object)
], ElasticsearchEnhancedFilterModel.prototype, "invalid", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ElasticsearchEnhancedFilterModel.prototype, "id", null);
//# sourceMappingURL=elasticsearch-filter.js.map